import { takeEvery, select, put } from "redux-saga/effects";

import types from "actions/actionTypes";
import { getWorkListColumnState } from "selector/UISelectors";
import { setColumnActive } from "actions/workItemsActions";

export const MIN_ACTIVE_COLS = 3;

const getActiveColumns = columnStateObject =>
  Object.keys(columnStateObject).filter(col => columnStateObject[col].active);

export function* checkMinActiveColumns(action) {
  if (action.payload.isActive) {
    return;
  }

  const columnState = yield select(getWorkListColumnState);
  const activeColumns = getActiveColumns(columnState);
  if (activeColumns.length < MIN_ACTIVE_COLS) {
    yield put(setColumnActive(action.payload.column, true));
  }
}

export default [takeEvery(types.SET_COLUMN_ACTIVE, checkMinActiveColumns)];
